// extracted by mini-css-extract-plugin
module.exports = {"bestOffer":"best_offer_bestOffer__2c8-S"};